import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { DirectLoginState, getDirectLogin, LoginService } from '@uxdf/direct-shared-lib';
import { CmsPageTypes } from '@uxdf/direct-shared-lib';

import { __config_social_links } from '../../../redux/reducers';
import { setLocaleAction } from '@uxdf/locale-manager';

@Component({
  standalone: false,
  selector: 'app-exceptions-page',
  templateUrl: './exceptions.component.html'
})
export class ExceptionsComponent implements OnInit, OnDestroy {
  @Input() code: any;
  @Input() socials: any;
  subscription: any;
  getMenuListSubscription: Subscription;
  directLoginSubscription: Subscription;
  readonly landingNewDesignCopyrights = $localize`:@@exceptions.landingNewDesignCopyrights:Amadeus IT Group SA`;
  readonly landingTermsOfUse = $localize`:@@exceptions.landingTermsOfUse:Terms of Use`;
  readonly landingCookiesPolicy = $localize`:@@exceptions.landingCookiesPolicy:Cookies Policy`;
  readonly landingPrivacyPolicy = $localize`:@@exceptions.landingPrivacyPolicy:Privacy Policy`;
  readonly footerContentMarketing_impressum = $localize`:@@exceptions.footerContentMarketing-impressum:marketing impressum`;

  CMS;

  facebook = '';
  linkedin = '';
  twitter = '';
  youtube = '';

  legal: [];

  storeCode;
  language;

  userLoggedOut = true;
  showSocial = false;
  errorPageType = '';
  errorPageTitle = '';
  errorPageSubtitle = '';
  errorhref = '';
  readonly errorIconPath = '/assets/images/svg_ico/icons.svg#error_';

  private socialState$: Observable<any>;
  private directLogin$: Observable<DirectLoginState>;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store<any>,
    // private readonly languageService: LanguageService,
    // private readonly ngxTranslator: NgxTranslateService,
    public readonly cms: CmsPageTypes,
    private readonly loginService: LoginService
  ) {
    this.storeCode = sessionStorage.getItem('landingStoreCode');
    this.language = sessionStorage.getItem('landingLang');
  }

  ngOnInit() {
    this.CMS = this.cms.code;
    this.subscription = this.route.data.subscribe(data => {
      this.code = data.code;
      switch (this.code) {
        case 404:
          this.errorPageType = $localize`:@@exceptions.components.errorPageType404:Page not found`;
          this.errorPageTitle = $localize`:@@exceptions.components.errorPageTitle404:Sorry, looks like the page you're trying to reach has not been found`;
          this.errorPageSubtitle = $localize`:@@exceptions.components.errorPageSubtitle404:
          Make sure that the website URL in the address bar of your browser is spelled and formatted correctly.
          The content might have been moved or may no longer be available.`;
          this.errorhref = this.errorIconPath + this.code;
          break;

        case 403:
          this.errorPageType = $localize`:@@exceptions.components.errorPageType403:Forbidden`;
          this.errorPageTitle = $localize`:@@exceptions.components.errorPageTitle403:403 <br>No access to the page`;
          this.errorPageSubtitle = $localize`:@@exceptions.components.errorPageSubtitle403:Oops...it seems the URL you are trying to reach is inaccessible.`;
          this.errorhref = this.errorIconPath + this.code;
          break;

        case 500:
          this.errorPageType = $localize`:@@exceptions.components.errorPageType500:Internal server error`;
          this.errorPageTitle = $localize`:@@exceptions.components.errorPageTitle500:Sorry, it's not you.<br>It's us, but we're on it.`;
          this.errorPageSubtitle = $localize`:@@exceptions.components.errorPageSubtitle500:
          Don't worry, our best people have been automatically notified of this issue
          and they are working on it.Please try again in a few minutes.`;
          this.errorhref = this.errorIconPath + this.code;
          break;

        default:
          break;
      }

      this.directLogin$ = this.store.pipe(select(getDirectLogin));
      this.directLoginSubscription = this.directLogin$.subscribe(directLogin => {
        if (directLogin.loginStatus === 'LOGIN') {
          this.socialState$ = this.store.pipe(select(__config_social_links));
          this.socialState$.subscribe(response => {
            if (!response.isLoading && response.config) {
              this.showSocial = true;
              this.userLoggedOut = false;

              this.facebook = response.config.facebook;
              this.linkedin = response.config.linkedin;
              this.twitter = response.config.twitter;
              this.youtube = response.config.youtube;
            }
          });
        } else if (this.storeCode && this.language) {
          this.getMenuListSubscription = this.loginService.getMenuList(this.storeCode).subscribe(menu => {
            this.legal = menu.legal;

            this.store.dispatch(setLocaleAction({ bcpLocale: this.language }));

            this.showSocial = false;
            this.userLoggedOut = true;
          });
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
    if (this.directLoginSubscription && !this.directLoginSubscription.closed) {
      this.directLoginSubscription.unsubscribe();
    }
    if (this.getMenuListSubscription && !this.getMenuListSubscription.closed) {
      this.getMenuListSubscription.unsubscribe();
    }
  }
}
